var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagamentiPrevisti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 339.23 339.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    fill: "currentColor",
    d: "M250.54,80A169.62,169.62,0,1,0,370.3,129.65,169.61,169.61,0,0,0,250.54,80Zm0,310.11A140.84,140.84,0,1,1,350,348.85,140.85,140.85,0,0,1,250.54,390.1Z",
    transform: "translate(-80.77 -79.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    fill: "currentColor",
    d: "M188.16,289.06a17.27,17.27,0,0,0-.53,1.73,9.62,9.62,0,0,1-.42,1.44,16.52,16.52,0,0,0,0,6.57,5.18,5.18,0,0,0,.42,1.44,9.68,9.68,0,0,0,1.35,3.31,2.62,2.62,0,0,0,.72,1.29,16.4,16.4,0,0,0,2.1,2.53l46.89,46.89a16.93,16.93,0,0,0,2.59,2.11c.38.29.87.43,1.25.67a9.44,9.44,0,0,0,3.3,1.39,7.72,7.72,0,0,1,1.44.43,16.89,16.89,0,0,0,6.57,0,5.45,5.45,0,0,0,1.44-.43,9.49,9.49,0,0,0,3.31-1.39c.43,0,.87-.43,1.25-.67a16.93,16.93,0,0,0,2.59-2.11l46.88-46.89a15.92,15.92,0,0,0,2.11-2.53c.29-.43.49-.87.72-1.29a9.74,9.74,0,0,0,1.34-3.31,9.62,9.62,0,0,1,.42-1.44,16.52,16.52,0,0,0,0-6.57,5.54,5.54,0,0,0-.42-1.44,9.66,9.66,0,0,0-1.34-3.31,2.58,2.58,0,0,0-.72-1.29,16.85,16.85,0,0,0-4.79-4.8c-.38-.28-.87-.42-1.25-.66a9.46,9.46,0,0,0-3.3-1.4,7.72,7.72,0,0,1-1.44-.43h0a17.52,17.52,0,0,0-3.31-.33H267.22V156.37a16.78,16.78,0,0,0-33.56,0V278.66h-30.1a17.53,17.53,0,0,0-3.31.34,5.2,5.2,0,0,0-1.44.43,9.57,9.57,0,0,0-3.31,1.39c-.42,0-.86.43-1.24.67a17,17,0,0,0-4.8,4.79c-.29.43-.48.87-.71,1.29a10.49,10.49,0,0,0-.58,1.49Z",
    transform: "translate(-80.77 -79.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagamentiPrevisti);
export default __webpack_public_path__ + "static/media/pagamenti-previsti.37f3657e2d1d475698182c2e375074a6.svg";
export { ForwardRef as ReactComponent };